import axios, { AxiosError } from "axios";

import { ParentConsultationModel, parseConsultationDataModel } from "@teamprevent/common/managerFeedbackOnReport/models";
import { Questionnaire } from "@teamprevent/common/questionnaires/model";

const buildUrl = () => "/api/managerFeedbackOnReport";

const getConsultationData = async (customerId: string, ohCaseId: string, taskId: string) => {
    try {
        const response = await axios.get<ParentConsultationModel>(`${buildUrl()}/customer/${customerId}/ohCase/${ohCaseId}/${taskId}/consultationData`);
        return parseConsultationDataModel(response.data);
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError?.response?.status === 400) {
            const error = { message: axiosError?.response?.data, status: 400 };
            throw error;
        }
        else if (axiosError?.response?.status === 404) {
            return null;
        }

        throw ex;
    }
};

const loadQuestionnaire = async (customerId: string, ohCaseId: string, taskId: string) => {
    try {
        const response = await axios.get<Questionnaire>(`${buildUrl()}/customer/${customerId}/ohCase/${ohCaseId}/${taskId}/getQuestionnaire`);
        return response.data;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError?.response?.status === 400) {
            const error = { message: axiosError?.response?.data, status: 400 };
            throw error;
        }
        else if (axiosError?.response?.status === 404) {
            return null;
        }

        throw ex;
    }
};

export const managerFeedbackOnReportApi = { getConsultationData, loadQuestionnaire };
